
Ninja.register( 'product', async function( Ninja ) {

  class NinjaProduct {

    constructor( elem, type = 'main' ) {

      if( !elem ) {
        return;
      }

      Object.assign(
        this,
        {
          type,
          elem
        }
      );

      const productJsonScriptTag = elem.querySelector( 'script.ninja-product-json' );
      try {
        const productJson = productJsonScriptTag ? JSON.parse( productJsonScriptTag.innerHTML ) : null;
        Object.assign( this, productJson );
      }
      catch(e) {
        console.log(`No product JSON found.`);
        return;
      }

      if( type === 'main' || type === 'quick-view' ) {

        FoxTheme.pubsub.subscribe( FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,  e => {

          const variant = this.getVariantById( e.data.variant?.id );
          if( variant ) {
            this.currentVariant = variant;
            this.setPricePerUnit();
          }

        } );

      }

      this.setCurrentVariant();
      if( this.currentVariant ) {
        this.setPricePerUnit();
      }

    };

    setCurrentVariant() {

      if( !this.variants || !this.variants.length ) {
        return;
      }

      let variant;

      if( this.type === 'main' ) {

        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const variantId = params.get('variant');

        if( variantId ) {
          variant = this.getVariantById( parseInt( variantId ) );
          this.currentVariant = variant;
          return variant;
        }

      }
      else if( this.type === 'card' ) {

        variant = this.variants[ this.variants.length - 1 ];
        this.currentVariant = variant;
        return variant;

      }

      this.currentVariant = this.variants[0];
      return this.currentVariant;

    }

    getVariantById( variantId ) {

      if( !this.variants ) {
        return null;
      }

      const variants = this.variants;
      for( let i = 0; i < variants.length; i++ ) {
        if( variants[i].id === variantId ) {
          return variants[i];
        }
      }

      return null;

    }


    setPricePerUnit() {

      if( !this.currentVariant ) {
        return;
      }

      const pricePerUnitElem = this.elem.querySelector( '.ninja__price-per-unit__snippet .ninja__price-per-unit__text' );
      if( pricePerUnitElem ) {

        let variantUnitCount;
        const variantUnitCountMatch = this.currentVariant.option1 ? this.currentVariant.option1.match(/([0-9]+) units/i) : null;
        if( variantUnitCountMatch ) {
          variantUnitCount = parseInt(variantUnitCountMatch[1]);
        }
        else if ( this.currentVariant.option1.match(/^[0-9]+$/) ) {
          variantUnitCount = parseInt( this.currentVariant.option1 );
        }

        if( variantUnitCount ) {
          const variantUnitPrice = this.currentVariant.price / variantUnitCount;

          if( this.type === 'card' && this.variants.length > 1 ) {
            pricePerUnitElem.innerHTML = `As low as ${FoxTheme.Currency.formatMoney( variantUnitPrice, FoxTheme.settings.moneyFormat )} per unit!`;
          }
          else {
            pricePerUnitElem.innerHTML = 'Price Per Unit: ' + FoxTheme.Currency.formatMoney( variantUnitPrice, FoxTheme.settings.moneyFormat );
          }

        }

      }

    }

  }

  const api = {
    NinjaProduct
  };


  function initProducts() {

    Ninja.productCards = Ninja.productCards || [];

    const mainProductElem =  document.querySelector( 'product-info.section-main-product' );
    if ( mainProductElem ) {
      Ninja.mainProduct = new NinjaProduct( mainProductElem, 'main' );
    }

    const cardProductElems = document.querySelectorAll( '.product-card' );
    for( const cardProductElem of cardProductElems ) {
      Ninja.productCards.push( new NinjaProduct( cardProductElem, 'card' ) );
    }

    document.addEventListener('quick-view:open', _e => {
      const quickViewElem = document.querySelector('.quick-view__content product-info');
      Ninja.quickViewProduct = new NinjaProduct( quickViewElem, 'quick-view' );
    });

  };
  initProducts();

  return api;
});
